import { createSelector } from 'reselect';

import type { RootState } from 'config/store/reducers';

const getState = (state: RootState) => state.intl;

export const getTranslations = createSelector(getState, (intl) => intl.translations);
